import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';

const Stats = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const stats = [
    { value: t('stats.stat1Value'), label: t('stats.stat1Label') },
    { value: t('stats.stat2Value'), label: t('stats.stat2Label') },
    { value: t('stats.stat3Value'), label: t('stats.stat3Label') },
  ];

  return (
    <section ref={sectionRef} className="section-spacing bg-white">
      <div className="container-custom px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 md:gap-lg">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className={`text-center transition-all duration-700 ${
                isVisible 
                  ? 'opacity-100 translate-y-0 scale-100' 
                  : 'opacity-0 translate-y-8 scale-95'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className={`stat-number mb-2 sm:mb-3 transition-all duration-500 ${
                isVisible ? 'blur-0' : 'blur-sm'
              }`} style={{ transitionDelay: `${index * 150 + 200}ms` }}>
                {stat.value}
              </div>
              <div className="text-sm sm:text-base text-gray-600 font-medium px-2">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
